import { render, staticRenderFns } from "./TcwPopupTag.vue?vue&type=template&id=57a1bc17&scoped=true&"
import script from "./TcwPopupTag.vue?vue&type=script&lang=ts&"
export * from "./TcwPopupTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a1bc17",
  null
  
)

export default component.exports